import React from 'react'
import Label from '@/components/controls/Label'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

const Input: React.FC<InputProps> = ({ label, error, className, ...props }) => {
  return (
    <div className="mb-6">
      {label && (
        <Label>
          {label}
        </Label>
      )}
      <input
        className={`bg-input appearance-none border-2 ${error ? 'border-danger' : 'border-border'} rounded-lg w-full py-3 px-4 text-foreground leading-tight focus:outline-none focus:bg-background focus:border-primary transition-colors ${className || ''}`}
        {...props}
      />
      {error && (
        <p className="text-danger text-sm mt-1">{error}</p>
      )}
    </div>
  )
}

export default Input
